import { useEffect, useState } from 'react';

import { useLocation } from 'react-router';

type Params = Readonly<{
	armed: boolean;
	hasCrossedThreshold: boolean;
	markAsShown: () => void;
}>;

/**
 * Latches the eligibility crossing to the page it happened on. Stays `true` for that page even after
 * consuming the session flag flips `armed` off, and resets automatically on navigation (hide-on-nav)
 * since the keyed pathname no longer matches. Consumes the session flag once, as a side effect.
 */
export function useToastActivation({ armed, hasCrossedThreshold, markAsShown }: Params): boolean {
	const { pathname } = useLocation();
	const [activatedPathname, setActivatedPathname] = useState<string | null>(null);

	if (hasCrossedThreshold && armed && activatedPathname !== pathname) {
		// setState during render (React's documented derived-state pattern); converges via the guard.
		setActivatedPathname(pathname);
	}

	const activated = activatedPathname === pathname;

	useEffect(() => {
		if (activated) {
			markAsShown();
		}
	}, [activated, markAsShown]);

	return activated;
}
